<template>
    <div class="text-center mb-4 toggle central-toggle">
        <label class="d-flex justify-content-center align-items-center">
            <span class="toggle-label">{{ offLabel }}</span>
            <b-form-checkbox
                v-model="isActive"
                :name="name"
                switch
                size="lg"
                @change="toggleQueryParam"
            ></b-form-checkbox>
            <span class="toggle-label">{{ onLabel }}</span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        queryParam: {
            type: String,
            required: true
        },
        queryValue: {
            type: String,
            default: 'true'
        },
        onLabel: {
            type: String,
            required: true
        },
        offLabel: {
            type: String,
            required: true
        },
        name: {
            type: String,
            default: 'query-toggle'
        }
    },
    data() {
        return {
            isActive: this.checkIfActive()
        }
    },
    methods: {
        checkIfActive() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(this.queryParam) === this.queryValue;
        },
        toggleQueryParam() {
            const url = new URL(window.location.href);
            
            if (this.isActive) {
                url.searchParams.set(this.queryParam, this.queryValue);
            } else {
                url.searchParams.delete(this.queryParam);
            }
            
            window.location.href = url.toString();
        }
    }
}
</script>
